import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    requisitions: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_REQUISITION_SELECT_IDS (store, ids) {
      store.requisitions.selectIds = ids
    },
    REMOVE_REQUISITION_SELECT_IDS (store, ids) {
      store.requisitions.selectIds = store.requisitions.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_REQUISITION_SELECT_ID (store, id) {
      store.requisitions.selectId = id
    },
    SET_REQUISITION_FILTERS (store, filters) {
      store.requisitions.filters = filters
    },
    SET_REQUISITION_PAGINATE (store, val) {
      store.requisitions.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getRequisitions: (store, getters) => {
      return store.requisitions.selectIds.map((id) => {
        return getters['entities/requisitions/find'](id)
      })
    },
    getRequisitionsFilters: (store, getters) => {
      return store.requisitions.filters
    },
    getRequisitionsPaginate: (store, getters) => {
      return store.requisitions.paginate
    },
    getRequisition: (store, getters) => {
      return getters['entities/requisitions/find'](store.requisitions.selectId) || {}
    }
  },
  actions: {
    /*
    selectRequisitions
    */
    selectRequisitions ({commit, dispatch, getters, state}, filters) {
      return dispatch('getRequisitions', { ...filters, abortid: 'select-requisitions' })
      .then((response) => {
        commit('SET_REQUISITION_FILTERS', filters)
        commit('SET_REQUISITION_PAGINATE', response)
        commit('SET_REQUISITION_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectRequisitions
    */
    refreshSelectRequisitions ({commit, dispatch, getters, state}) {
      return dispatch('selectRequisitions', getters.getRequisitionsFilters)
    },
    /*
    selectRequisition
    */
    selectRequisition ({commit, dispatch, getters, state}, id) {
      return dispatch('getRequisitionById', id)
      .then((response) => {
        commit('SET_REQUISITION_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getRequisitions
    */
    getRequisitions ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/requisitions`, { params: filters })
      .then((response) => {
        return dispatch('entities/requisitions/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.requisitions || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getRequisitionById
    */
    getRequisitionById ({commit, dispatch, getters, state}, id) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/requisitions/${id}`)
      .then((response) => {
        return dispatch('entities/requisitions/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.requisitions[0]
      })
    },
    /*
    createRequisition
    */
    createRequisition ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/requisitions`, data)
      .then((response) => {
        return dispatch('entities/requisitions/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.requisitions[0]
      })
    },
    /*
    updateRequisition
    */
    updateRequisition ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/requisitions/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/requisitions/insert', {
          data: response.data
        })
      })
      .then((response) => {
        dispatch('setWarn', { status: 'success' })
        return response.requisitions[0]
      })
    },
    /*
    updateRequisitionAnalyze
    */
    updateRequisitionAnalyze ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/requisitions/${data._id}/analyze`)
      .then(response => {
        return dispatch('entities/requisitions/insert', {
          data: response.data
        })
      })
      .then((response) => {
        dispatch('setWarn', { status: 'success' })
        return response.requisitions[0]
      })
    },
    /*
    updateRequisitionArchive
    */
    updateRequisitionArchive ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/requisitions/${data._id}/archive`)
      .then(response => {
        return dispatch('entities/requisitions/insert', {
          data: response.data
        })
      })
      .then((response) => {
        dispatch('setWarn', { status: 'success' })
        return response.requisitions[0]
      })
    },
    /*
    followRequisition
    */
    followRequisition ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/requisitions/${data.requisition_id}/${data.action}`)
      .then((response) => {
        return dispatch('entities/requisitions/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.requisitions[0]
      })
    },
    /*
    deleteRequisition
    */
    deleteRequisition ({commit, dispatch, getters, state}, id) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/requisitions/${id}`)
      .then((response) => {
        commit('REMOVE_REQUISITION_SELECT_IDS', [id])
        dispatch('entities/requisitions/delete', id)
        return {}
      })
    },
    /*
    cloneRequisition
    */
    cloneRequisition ({commit, dispatch, getters, state}, id) {
      return axios
      .post(`/accounts/${getters.getAccount._id}/requisitions/${id}/clone`)
      .then((response) => {
        return dispatch('entities/requisitions/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.requisitions[0]
      })
    },
    /*
    redefinedApprovalflow
    */
    redefinedRequisitionApprovalflow ({commit, dispatch, getters, state}, id) {
      return axios
      .put(`/accounts/${getters.getAccount._id}/requisitions/${id}/approvalflow-redefined`, {})
      .then((response) => {
        if (getters.getRequisition) {
          dispatch('getRequisitionById', getters.getRequisition._id)
        }
        if (!(response && response.data)) {
          return null
        }
        return dispatch('entities/approvalflows/insert', {
          data: response.data
        }).then(response => {
          return response.approvalflows[0]
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Requisition.js